import { useState } from "react";
import Button from "../Button";
import FilterTextInput from "../FilterTextInput";
import {
  Edit2,
  FilterRemove,
  Warning2,
} from "iconsax-react";
import { useNavigate } from "react-router-dom";
import { SEATING_CHART, SEATS_MANAGEMENT_EDIT } from "../../Router/path";
import Paginator from "../Paginator";
import TableGuestList from "../TableGuestList";
import Can from "../Can";

const SeatManagementTable = ({
  data,
  meta,
  tableAvailabilitySelector,
  tableAvailability,
  setTableAvailability,
  handlePageClick,
  searchTerm,
  handleSearch,
  handleKeyDown,
  handlePerPageChange,
  perPage,
  clearFilter,
}) => {
  const [showModal, setShowModal] = useState(false);
  const [tableId, setTableId] = useState(null);

  const navigate = useNavigate();

  const toggleModal = () => {
    setShowModal(!showModal);
  };

  // const handleViewGuests = (tableId) => {
  //   try {
  //     axios
  //       .get(GET_TABLE_GUESTS_API, {
  //         headers: {
  //           Authorization: `Bearer ${sessionStorage.getItem("bearer_token")}`,
  //         },
  //         params: {
  //           tableId: tableId,
  //           eventId: sessionStorage.getItem("event_id"),
  //         },
  //       })
  //       .then((response) => {
  //         setTableGuests(response.data.data);
  //         setShowModal(true);
  //       })
  //       .catch((error) => {
  //         toast("Failed to fetch table guests", "error");
  //         console.log(error);
  //       });
  //   } catch (error) {
  //     toast("Failed to fetch table guests", "error");
  //     console.log(error);
  //   }
  // };

  return (
    <div className="flex flex-col border border-[#EFF0F2] w-full h-fit bg-white rounded-xl text-nowrap">
      {showModal && (
        <TableGuestList
          tableId={tableId}
          isOpen={showModal}
          toggleModal={toggleModal}
        />
      )}
      {/* Title */}
      <div className="flex w-full border-b border-[#EFF0F2] px-[24px] py-[16px] justify-between items-center">
        <h2>Seats Management</h2>
        <Can permission="view_seating_chart">
          <Button onClick={() => navigate(SEATING_CHART)}>
            Seatings Chart
          </Button>
        </Can>
      </div>

      {/* Table Availability Selector */}
      <div className="flex items-center px-[24px] gap-[24px] border-b border-[#EFF0F2]">
        {tableAvailabilitySelector &&
          tableAvailabilitySelector.map((item) => (
            <button
              className={`flex items-center py-[24px] gap-2 ${
                item.name === tableAvailability
                  ? "border-b border-[#5C4BF5] font-semibold text-[#5C4BF5]"
                  : "text-[#595F72] hover:text-[#5C4BF5]"
              } `}
              onClick={() => {
                setTableAvailability(item.name);
              }}
            >
              <span>{item.name}</span>
              <span className={`${item.color} py-[2px] px-[4px] rounded-md`}>
                {item.count}
              </span>
            </button>
          ))}
      </div>

      {/* Filters */}
      <div className="flex w-full border-b border-[#EFF0F2] px-[24px] py-[12px] gap-[8px] items-center justify-end">
        {clearFilter && searchTerm !== "" && (
          <FilterRemove
            size="16"
            onClick={clearFilter}
            variant="Bold"
            className="text-[#FF3030] hover:cursor-pointer hover:text-[#5C4BF5]"
          />
        )}
        <FilterTextInput
          value={searchTerm}
          onChange={handleSearch}
          onKeyDown={handleKeyDown}
        />
      </div>

      {/* Table data */}
      <div className="flex w-full h-full gap-[24px] no-scrollbar overflow-x-auto">
        {!data || data.length === 0 ? (
          <div className="flex w-full h-[290px] items-center border-[#EFF0F2] justify-center text-gray-500 text-[25px]">
            No table found
          </div>
        ) : (
          <table className="w-full h-full">
            {/* Table Header */}
            <tr className="w-full bg-[#F7F8F9] border-b border-[#EFF0F2]">
              {/* <th className="text-start px-[24px] py-[16px]">
                <input type="checkbox" />
              </th> */}
              <th className="text-start px-[24px] py-[16px]">Table Name</th>
              <th className="text-start px-[24px] py-[16px]">Assigned/Seats</th>
              <th className="text-start px-[24px] py-[16px]">Checked-In</th>
              <th className="text-start px-[24px] py-[16px]">Guests</th>
              <th className="text-start px-[24px] py-[16px]">
                Table Description
              </th>
              <th className="text-start px-[24px] py-[16px]"></th>
            </tr>

            {/* Table Body */}
            {data &&
              data.map((item) => (
                <tr
                  key={item.id}
                  className="w-full font-normal border-b last:border-none border-[#EFF0F2]"
                >
                  {/* <td className="text-start px-[24px] py-[16px]">
                    <input type="checkbox" />
                  </td> */}
                  <td className="px-[24px] py-[16px]">{item.name ?? "-"}</td>
                  <td className="px-[24px] py-[16px]">
                    <div className="flex flex-col w-full">
                      <p className="flex text-[12px] justify-between">
                        {item.guest_count} of {item.pax}{" "}
                        {item.guest_count > item.pax && (
                          <Warning2 size="16" color="#FF0000" variant="Bold" />
                        )}
                      </p>
                      <div className="relative w-full min-h-[4px] max-h-[4px] bg-[#E0E2E5] rounded-2xl">
                        <div
                          className={`absolute left-0 top-0 min-h-[4px] max-h-[4px] rounded-2xl ${
                            item.guest_count > item.pax
                              ? "bg-[#FF0000]"
                              : "bg-[#5C4BF5]"
                          }`}
                          style={{
                            width: `${
                              item.percentage > 100 ? 100 : item.percentage
                            }%`,
                          }}
                        ></div>
                      </div>
                    </div>
                  </td>
                  <td className="px-[24px] py-[16px]">
                    {item.guest_count_confirmed}
                  </td>
                  <td className="px-[24px] py-[16px]">
                    <Button
                      variant=""
                      className="hover:text-[#5C4BF5]"
                      onClick={() => {
                        setTableId(item.id);
                        toggleModal();
                      }}
                    >
                      View List
                    </Button>
                  </td>
                  <td className="px-[24px] py-[16px] max-w-[200px] truncate">
                    {item.description ?? "-"}
                  </td>
                  <td className="flex px-[24px] py-[16px] h-full gap-[12px] items-center justify-end">
                    <Can permission="edit_seat">
                      <span
                        className="flex text-[#5C4BF5] text-[14px] items-center hover:underline cursor-pointer"
                        onClick={() =>
                          navigate(SEATS_MANAGEMENT_EDIT, {
                            state: { tableId: item.id },
                          })
                        }
                      >
                        <Edit2 size="15" variant="Bold" />
                        Edit
                      </span>
                    </Can>
                  </td>
                </tr>
              ))}
          </table>
        )}
      </div>

      {/* Pagination */}
      {meta && (
        <Paginator
          meta={meta}
          perPage={perPage}
          handlePerPageChange={handlePerPageChange}
          handlePageClick={handlePageClick}
        />
      )}
    </div>
  );
};

export default SeatManagementTable;
